import { Component, Input } from '@angular/core';
export type FooterMenuItem = {
  label: string;
  link?: string;
  action?: () => void;
  items?: FooterMenuItem[];
};

@Component({
  selector: 'footer-menu-item',
  templateUrl: './footer-menu-item.component.html',
  styleUrls: ['./footer-menu-item.component.scss'],
  standalone: false,
})
export class FooterItemComponent {
  @Input()
  public readonly menuItem: FooterMenuItem;

  @Input()
  public readonly root: boolean;

  public active: boolean = false;

  constructor() {}

  public toggle(): void {
    this.active = !this.active;
  }

  public rootHasSubMenu(): boolean {
    return this.root && this.menuItem.items?.some((m) => m.items?.length);
  }
}
